import moment from 'moment'
import { getCalendar } from '../../api/api'

export const actionTypes = {
  FETCH_START: 'calendar/FETCH_START',
  FETCH_SUCCESS: 'calendar/FETCH_SUCCESS',
  FETCH_ERROR: 'calendar/FETCH_ERROR',
}

export const fetchCalendar = (brand, ship) => async dispatch => {
  const date = moment().format('YYYY-MM-DD')
  dispatch({ type: actionTypes.FETCH_START })
  try {
    const { data } = await getCalendar(date, brand, ship)
    return dispatch({
      type: actionTypes.FETCH_SUCCESS,
      payload: data?.data || {},
    })
  } catch (error) {
    return dispatch({ type: actionTypes.FETCH_ERROR })
  }
}
